/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Success = 'Website.PreorderCustomerNotification.Success';
export const SubHeader = 'Website.PreorderCustomerNotification.SubHeader';
